import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from "../../../app/store";
import {LocationOptionDTO} from "../../../api/generated";
import {locationApi, RequestStatus} from "../../../api/apiConfiguration";
import {SelectOption} from "../../elements/select/SelectDropdown";
import {prepareLocationNameWithId} from "./locationListSlice";

export const fetchLocationOptions = createAsyncThunk<Array<LocationOptionDTO>, undefined>(
    "locationOptions/fetchLocationOptions",
    (_payload) => {
        return locationApi.getLocationOptions();
    }
)

export interface LocationOptionsState {
    locationOptions: SelectOption<LocationOptionDTO>[]
    locationOptionsRequestStatus: RequestStatus
}

const buildInitialState = (): LocationOptionsState => {
    return {
        locationOptions: [] as SelectOption<LocationOptionDTO>[],
        locationOptionsRequestStatus: RequestStatus.NONE
    }
}

const initialState: LocationOptionsState = buildInitialState()

export const locationOptionsSlice = createSlice({
    name: 'locationOptions',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchLocationOptions.fulfilled, (state, {payload}) => {
            state.locationOptions = mapLocationListToOptions(payload)
            state.locationOptionsRequestStatus = RequestStatus.RESOLVED
        })
        builder.addCase(fetchLocationOptions.pending, (state) => {
            state.locationOptionsRequestStatus = RequestStatus.PENDING
        })
        builder.addCase(fetchLocationOptions.rejected, (state) => {
            state.locationOptionsRequestStatus = RequestStatus.REJECTED
        })
    },
});

export const mapLocationListToOptions = (locationOptions: LocationOptionDTO[]): SelectOption<LocationOptionDTO>[] => {
    return locationOptions.map(option => {
        return {
            value: option,
            label: prepareLocationNameWithId(option.locationName, option.publicId)
        }
    })
}

export const _ = locationOptionsSlice.actions;

export const locationOptionsSelector = (state: RootState): SelectOption<LocationOptionDTO>[] => state.locationOptions.locationOptions;
export const locationOptionsRequestStatusSelector = (state: RootState): RequestStatus => state.locationOptions.locationOptionsRequestStatus;
